<template>

	<div>
	  	<hooper ref="slider" sync="carousel" :centerMode="true" :autoPlay="false" :playSpeed="8000" :wheelControl="false" class="main">

		  	<slide v-for="(item, index) in sliders" class="item main" :key="item.id">
	        	<a :href="item.url"><img :src="item.file" /></a>
	      	</slide>
		  
		  <hooper-navigation slot="hooper-addons"></hooper-navigation>
		</hooper>

		<hooper :itemsToShow="Object.keys(sliders).length" :mouseDrag="false" :wheelControl="false" >
			
		  	<slide v-for="(item, index) in Object.values(sliders)" class="item aux" v-bind:style="{ backgroundImage: 'url(' + item.file + ')' }" >
		  		<div class="container" @click="select(index)">
		  			
	        		<span class="caption">{{item.name}}</span>
		  		</div>
	      	</slide>

		</hooper>
	
	</div>

</template>

<script>
  import { Hooper, Slide, Navigation as HooperNavigation  } from 'hooper';
  import 'hooper/dist/hooper.css';

  export default {
    name: 'Slider',
    components: {
      Hooper,
      Slide,
      HooperNavigation, 
    },
    data() {
    	return {
    		total: 5,
    	}
    },
    computed: {

	    sliders() {
	      return this.$store.getters['sliders/getSliders'];
	    },
	    
	},
	methods: {
		select(idx) {
			this.$refs.slider.slideTo(idx);
		},
		
	},
    created() {

	    /*this.$store.dispatch('sliders/loadSliders').then(function() { 
	      //this.loading = false; 
	    });*/

  	}
  }
</script>

<style lang="scss" scoped>
	
	.hooper {
		height: 150px;

		&.main {
			height: auto;
			
		}

	}
	.item {
		height: 150px;
		cursor: pointer;

		img {
			height: 150px;

		}
		&.main {
			width: 1000px;
			height: 500px;

			img {
				width: 1000px;
				height: 500px;
			}
		}
		&.aux {
			background-position: center;
			background-repeat: no-repeat;
			background-size: 200%;
			position: relative;

			&:hover {
				opacity: 0.75;
			}

			.container {
				background: rgba(0,0,0,0.25);
				width: 100%;
				height: 100%;
				position: absolute;
				left: 0;
				top: 0;

				.caption {
					background: rgba(0,0,0,0.8);
					color: #fff;
					text-align: center;
					width: 100%;
					position: absolute;
					bottom: 0;
					left: 0;
					padding: 10px;
					font-size: 10pt;

				}
			}

		}
	}

	

</style>


<style lang="scss">

	.hooper-navigation {
		background: #222;

		button {
			right: 0;
		    background: var(--main-color);
		    width: 100px;
		    height: 100px;
		    outline: none;

			&.hooper-prev {
				margin-left: -80px;
			}
			&.hooper-next {
		    	margin-right: -80px;
			}
			svg {
				width: 50px;
				height: 50px;
				fill: #fff;
			}
		}
	}

</style>